import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import signup from './views/sign-up'
import Login from './views/Login'
import forget from './views/forger-password'
import Build from './views/Build.vue'
import AI from './views/AI.vue'
import nlp from './views/nlp'
import Bots from './views/Bots'
import settings from './views/settings'
import publish from './views/publish'
import users from './views/users'
import analytics from "./views/analytics";
import filters from "./views/filters";
import page404 from "./views/404"
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { layout: 'no-sidebar'}
    },
    {
      path: '/sign-up',
      name: 'signup',
      component: signup,
      meta: { layout: 'no-sidebar'}
    },
    {
      path: '/forget-password',
      name: 'forget',
      component: forget,
      meta: { layout: 'no-sidebar'}
    },
    {
      path: '/build',
      name: 'build',
      component: Build,
      meta: { layout: 'default', permission: 1}
    },
    {
      path: '/ai',
      name: 'ai',
      component: AI,
      meta: { layout: 'default', permission: 1}
    },
    {
      path: '/nlp',
      name: 'nlp',
      component: nlp,
      meta: { layout: 'default', permission: 1}
    },
    {
      path: '/settings',
      name: 'settings',
      component: settings,
      meta: { layout: 'default', permission: 1}
    },
    {
      path: '/publish',
      name: 'publish',
      component: publish,
      meta: { layout: 'default', permission: 1}
    },
    {
      path: '/',
      name: 'bots',
      component: Bots,
      meta: { layout: 'TopHeader', permission: 2}
    },
    {
      path: '/users',
      name: 'users',
      component: users,
      meta: { layout: 'default', permission: 1}
    },
    {
      path: '/insights',
      name: 'analytics',
      component: analytics,
      meta: { layout: 'default', permission: 2}
    },
    {
      path: '/filters',
      name: 'filters',
      component: filters,
      meta: { layout: 'default', permission: 3}
    },
    {
      path: '/404',
      name: '404',
      component: page404,
      meta: { layout: 'default', permission: 2}
    }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  if (!store.state.user.userToken && to.path !== '/login' && to.path !== '/forget-password/' && to.path !== '/sign-up') {
    return next('/login');
  }
  if (store.state.user.userToken && to.path === '/login') {
    return next('/');
  }

  if (to.meta.permission === 1 && store.state.user.roleId !== 1) {
    return next('/insights')
  }

  if (to.meta.permission === 3 && store.state.user.roleId === 2) {
    return next('/insights')
  }

  next();
})

export default router
